import { render, staticRenderFns } from "./ui-textarea.vue?vue&type=template&id=b05a0230&scoped=true"
import script from "./ui-textarea.vue?vue&type=script&lang=js"
export * from "./ui-textarea.vue?vue&type=script&lang=js"
import style0 from "./ui-textarea.vue?vue&type=style&index=0&id=b05a0230&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05a0230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b05a0230')) {
      api.createRecord('b05a0230', component.options)
    } else {
      api.reload('b05a0230', component.options)
    }
    module.hot.accept("./ui-textarea.vue?vue&type=template&id=b05a0230&scoped=true", function () {
      api.rerender('b05a0230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/textarea/ui-textarea.vue"
export default component.exports